import { cn } from '@utils/cn';
import { FC, ReactNode } from 'react';

const WIDTHS = {
  /** Forms, prose, settings, onboarding. */
  narrow: 'max-w-[var(--layout-narrow)]',
  /** Dashboards and detail views. */
  default: 'max-w-[var(--layout-default)]',
  /** Data tables and card grids — the page max-width. */
  wide: 'max-w-[var(--layout-wide)]',
  /** Chat and anything that owns its own scroll region. */
  full: 'max-w-none'
} as const;

type PageContainerProps = {
  width?: keyof typeof WIDTHS;
  gutter?: 'default' | 'none';
  bottomInset?: boolean;
  className?: string;
  children: ReactNode;
};

const PageContainer: FC<PageContainerProps> = ({
  width = 'default',
  gutter = 'default',
  bottomInset = false,
  className,
  children
}) => (
  <div
    className={cn(
      'mx-auto w-full',
      WIDTHS[width],
      gutter === 'default' && 'px-0 desktop-chrome:px-1',
      bottomInset && 'pb-[calc(var(--safe-bottom)+1rem)]',
      className
    )}
  >
    {children}
  </div>
);

export default PageContainer;
